import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import html2canvas from "html2canvas";

import moment from "moment";

import { defaultFilter } from "../../utils/chartsData";
import { formatErrorMessage } from "../../utils/formatError";
import {
  CheckBeforeCreate,
  dataForCreate,
  dataForProjectRoutesCheckboxes,
  dataForCreateVacancyModal,
} from "../../utils/checkBeforeCreate";
import {
  actionUnloadReportsConsolidated,
  actionUnloadCustomerReportsData,
  actionUnloadReportsWithLinks,
  actionUnloadCustomerReports,
  actionUpdateDeliveryStatus,
  actionExportAverageFacing,
  actionUnloadReportsPhotos,
  actionImportReportLogins,
  actionUnloadClientReport,
  actionUnloadReportsList,
  actionImportReportKPI,
  actionGetUserReports,
  actionUnloadHotline,
  actionShareOfShelf,
  actionCopyReports,
  actionCreateGeo,
  actionExportOsa,
  actionGetEmployeesListConditional,
  actionNewReportsCreation,
} from "../../redux/action/userReports/actionUserReports";
import {
  actionImportCoefficients,
} from "../../redux/action/contracts/actionContracts";
import {
  actionSetSingleReportSettings,
  actionClientRequestReport,
  actionCancelReportReview,
  actionDeleteReportPhotos,
  actionClientAcceptReport,
  actionCancelReportClaim,
  actionRevisionReport,
  actionApproveReport,
  actionRejectReport,
  actionDeleteReport,
  actionDeclineRate,
  actionAcceptRate,
  actionCopyReport,
} from "../../redux/action/userSingleReport/actionUserSingleReport";
import {
  actionUpdateVacancy,
  actionCreateVacancy,
  actionVacanciesExport,
  actionRemoveSelections,
} from "../../redux/action/recruiting/actionVacancy";
import { actionCreateApplication } from "../../redux/action/recruiting/actionApplicationForm";
import {
  actionEditVisibleEmployees,
  actionTableEmployeesList,
} from "../../redux/action/accessRights/actionUsersList";
import {
  actionExportTanderProducts,
  actionImportProducts,
} from "../../redux/action/tunder/actionGoods";

import { reducerSingleApplicationErrors } from "../../redux/reducer/recruiting/reducers/reducerSingleApplication";
import {
  actionCreateExpiredReports,
  actionDeleteExpiredReports,
  actionExportExpiredReports,
  actionGetFiltersExpiredReports,
} from "../../redux/action/userReports/actionExpiredReports";
import { actionUnloadEmployeesList } from "../../redux/action/employees/actionEmployeesList";
import {
  reducerGetVacantRoutes,
  reducerClearInputValuesNoModal,
} from "../../redux/reducer/projects/reducers/reduserVacantRoutesListNoModal";
import {
  reducerSelectedUpdateStatus,
  reducerAdminReportsSettings,
  reducerSelectedReports,
  reducerReportsSettings,
  reducerReportsStatus,
  reducerHeaderBtn,
} from "../../redux/reducer/userReports/reducers/userReports";
import {
  reducerSelectedAdminReportSettings,
  reducerSingleReportSettingsOptions,
  reducerSelectedReportSettings,
  reducerDeletePhotosId,
} from "../../redux/reducer/userSingleReport/reducers/userSingleReport";
import {
  reducerHandleErrors,
  reducerCreateVacancyInputValues,
} from "../../redux/reducer/recruiting/reducers/reducerCreateVacancy";
import {
  reducerVacancyListSettings,
  reducerVacancyStatus,
  reducerVacancyStatusMessage,
} from "../../redux/reducer/recruiting/reducers/reducerVacancy";
import {
  reducerRoutesSettings,
  reducerRoutesStatus,
} from "../../redux/reducer/projects/reducers/reducerRoutesList";
import {
  reducerSetPending,
  reducerVacantRoutesSettings,
  reducerVacantRoutesStatus,
  reducerUpdatedData,
  reducerVacantRoutesInputValues,
} from "../../redux/reducer/projects/reducers/reducerVacantRoutesList";
import {
  reducerSingleVacancyIV,
  reducerGetSingleVacancy,
  reducerSingleVacancyStatus,
  reducerSingleVacancyStatusMessage,
} from "../../redux/reducer/recruiting/reducers/reducerSingleVacancy";

import { reducerEmployeesListSettings } from "../../redux/reducer/employees/reducers/employeesList";
import { reducerFiredEmployeesListSettings } from "../../redux/reducer/employees/reducers/firedEmployees";
import { reducerClearFilters } from "../../redux/reducer/accessRights/reducers/usersList";
import { reducerVisitScheduleHistory } from "../../redux/reducer/userSingleReport/reducers/visitSchedule";
import {
  reducerExpiredRecordsModalCreateValues,
  reducerExpiredReportsSettings,
  reducerExpiredReportsStatus,
} from "../../redux/reducer/userReports/reducers/expiredReports";
import {
  reducerDesktopSetting,
  reducerSelectCharts,
  reducerModalFilters,
  reducerDesktopName,
  reducerEditDesktop,
  reducerNewCharts,
  reducerAddCharts,
  reducerChartsFilters,
  reducerChangeDataCharts,
  reducerPendingCharts,
  reducerSettingCharts,
} from "../../redux/reducer/charts/reducer/reducerCharts";
import {
    reducerConsolidatedBudgetStatus
} from "../../redux/reducer/consolidatedbudget/reducers/reducerConsolidatedBudget";
import { actionUnloadScheduleInExcel } from "../../redux/action/userSingleReport/actionVisitSchedule";
import {
  actionUnloadIntegrationErrors,
  actionImportReport,
} from "../../redux/action/easymerch/actionIntegrationErrors";
import { actionSendRoutesToEasyMerch } from "../../redux/action/easymerch/actionUsers";
import { actionUnloadOutlets } from "../../redux/action/easymerch/actionOutlets";
import { actionImportPos } from "../../redux/action/tunder/actionRetailOutlets";
import { AppDispatch } from "../../redux/reducer/store";
import AdminSingleReportSettingsSection from "./sections/adminSingleReportSettingsSection";
import CustomerReportsSettingsSection from "./sections/customerReportsSettingsSection";
import ExpiredReportsSettingsSection from "./sections/expiredReportsSettingsSection";
import EmployeesListSettingsSection from "./sections/employeesListSettingsSection";
import UpdateDeliveryStatusSection from "./sections/updateDeliveryStatusSections";
import VacantRoutesSettingsSection from "./sections/vacantRoutesSettingsSection";
import AdminReportsSettingsSection from "./sections/adminReportsSettingsSection";
import SingleReportSettingsSection from "./sections/singleReportSettingsSection";
import ReinstateAnEmployeeSection from "./sections/reinstateAnEmployeeSection";
import ScheduleAddressInfoSection from "./sections/scheduleAddressInfoSection";
import VacancyListSettingsSection from "./sections/vacancyListSettingsSection";
import UnloadReportsPhotoSection from "./sections/unloadReportsPhotoSection";
import UpdateReviewStatusSection from "./sections/updateReviewStatusSection";
import LostVacancyRoutestSection from "./sections/lostVacancyRoutestSection";
import AddRouteOnVacancySection from "./sections/addRouteonVacancySection";
import FiredListSettingsSection from "./sections/firedListSettingsSection";
import ChangeEmployeePaySection from "./sections/changeEmployeePaySection";
import VacancyCreateNewSection from "./sections/vacancyNewCreateSection";
import UpdateRateStatusSection from "./sections/updateRateStatusSection";
import ScreenshotChartSection from "./sections/screenshotChartsSection";
import AddedDesktopOnCharts from "./sections/addedDesktopOnChartsSection";
import EditDesktopOnCharts from "./sections/editDesktopOnChartsSection";
import OutletsDownloadSection from "./sections/outletsDownloadSection";
import FiredAnEmployeeSection from "./sections/firedAnEmployeeSection";
import RoutesSettingsSection from "./sections/routesSettingsSection";
import ChartsSettingsSection from "./sections/chartsSettingsSection";
import BlockEmployeeSection from "./sections/blockEmployeeSection";
import VacancyUpdateSection from "./sections/vacancyUpdateSection";
import FiltersChartSection from "./sections/filtersChartsSection";
import DeletePhotosSection from "./sections/deletePhotosSection";
import DeleteReportSection from "./sections/deleteReportSection";
import ChangeColorSection from "./sections/changeColorSection";
import DeleteRouteSection from "./sections/deleteRouteSection";
import ReportCheckSection from "./sections/reportCheckSection";
import NewApplication from "./sections/newApplicationSection";
import NavigateToSection from "./sections/navigateToSection";
import CopyReportSection from "./sections/copyReportSection";
import NewUsersClaims from "./sections/newEmployeesSection";
import CreateGeoSection from "./sections/createGeoSection";
import AddChartSection from "./sections/addChartSection";
import CreateVacancy from "./sections/createVacancy";
import LimitSection from "./sections/limitSection";

import Blackout from "../custom/blackout/blackout";
import { IRoutesOptions, IProjectOptions } from "../../types/routeInterfaces";
import {IReportCriteriasOptions, IReportsOptions} from "../../types/reportsInterfaces";

import Excel from "../../assets/icons/excel.svg";
import Zip from "../../assets/icons/zip.svg";
import Close from "../../assets/icons/close.svg";
import "../../scss/App.scss";
import styles from "./headerBtn.module.scss";
import { IUserOptions } from "../../types/interfaces";
import { actionUploadStartShift } from "../../redux/action/projects/actionRoutes";
import LegendMapSection from "./sections/legendMapSection";
import clsx from "clsx";
import { actionAddDesktop } from "../../redux/action/charts/actionCharts";
import CreateExpiredReportsSection from "./sections/createExpiredReportsSection";
import { actionExportSignals } from "../../redux/action/tunder/actionSignals";
import {actionConsolidatedBudgeCreate} from "../../redux/action/consolidatedbudget/actionConsolidatedBudget";
import ConsolidatedBudgetExportSection from "./sections/consolidatedBudgetExportSection";

interface IHeaderBtnProps {
  modalTitle: string;
  content: string;
  purpose: string;
  selectId?: number;
  hasIcon?: string;
  action?: any;
  inputValuesCharts?: any;
  dataCharts?: any;
}

const unloadActions: any = {
  unloadReportsConsolidated: actionUnloadReportsConsolidated,
  unloadCustomerReportsData: actionUnloadCustomerReportsData,
  unloadReportsWithLinks: actionUnloadReportsWithLinks,
  unloadCustomerReports: actionUnloadCustomerReports,
  unloadReportsPhotos: actionUnloadReportsPhotos,
  unloadExpiredList: actionExportExpiredReports,
  unloadClientReport: actionUnloadClientReport,
  unloadReportsTander: actionGetEmployeesListConditional,
  unloadReportsList: actionUnloadReportsList,
  averageFacing: actionExportAverageFacing,
  unloadHotline: actionUnloadHotline,
  shelfShare: actionShareOfShelf,
  osa: actionExportOsa,
  unloadStafftReport: actionUnloadEmployeesList,
  companyStaff: actionUnloadEmployeesList,
};

const copyActions: any = {
  copyReport: actionCopyReport,
  copyReports: actionCopyReports,
};

const HeaderBtn: FC<IHeaderBtnProps> = ({
  content,
  purpose,
  modalTitle,
  selectId,
  hasIcon,
  action,
  inputValuesCharts,
  dataCharts,
}) => {
  const dispatch: any = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const {
    adminReportsSettings,
    reportsInputValues,
    selectedReportsId,
    actualModalTitle,
    reportsSettings,
    actualPurpose,
    reports,
    openModal,
  } = useSelector((state: any) => state.userReports.userReports);
    const {selectedProjectsId} = useSelector((state: any) => state.consolidatedbudget.projects);
  const expiredReportsModalData = useSelector((state: any) => state.userReports.expiredReports.expiredRecordsModalCreateValues);
  const expiredReportsFilters = useSelector((state: any) => state.userReports.expiredReports.expiredReportsFilters);
  const { selectedUsers } = useSelector((state: any) => state.easymerch.users);
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const { report, photos, settings, adminSettings, list } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );
  const { page, limit, offset, outletsInputValues } = useSelector(
    (state: any) => state.easymerch.outlets
  );
  const {
    reportsId,
    reports: expiredReportsList,
    expiredReportsSettings,
  } = useSelector((state: any) => state.userReports.expiredReports);
  const { isOpenHistory } = useSelector(
    (state: any) => state.userSingleReport.visitSchedule
  );
  const { vacancyCreateInputValues } = useSelector(
    (state: any) => state.recruiting.createVacancy
  );
  const {
    data: singleVacancyData,
    inputValues,
    editForm,
  } = useSelector((state: any) => state.recruiting.singleVacancy);
  const { employeesListSettings } = useSelector(
    (state: any) => state.employees.employeesList
  );
  const { firedListSettings } = useSelector(
    (state: any) => state.employees.firedEmployeesList
  );

  const { routesSettings, vacantCBnew } = useSelector(
    (state: any) => state.projects.routes
  );

  const { vacantRoutesSettings, vacantCheckboxes, vacantCheckboxesList } =
    useSelector((state: any) => state.projects.vacantRoutes);

  const { vacantCheckboxesNoModule } = useSelector(
    (state: any) => state.projects.vacantRoutesNoModal
  );

  const { selectedUserId } = useSelector((state: any) => state.roles.usersList);

  const { applicationCreateIV } = useSelector(
    (state: any) => state.recruiting.applicationCreate
  );

  const {
    selectedVacancy,
    applicationData,
    vacancyListSettings,
    selectedVacanciesId,
  } = useSelector((state: any) => state.recruiting.vacancyList);

  const { data: application, applicationInputValues } = useSelector(
    (state: any) => state.recruiting.singleApplication
  );

  const { employeeStatus, selectedEmployeesId } = useSelector(
    (state: any) => state.employees?.employeesList
  );
  const { selectChartsType, modalFilters, desktopList } = useSelector(
    (state: any) => state.charts?.chartsList
  );

  const [selectedActionOption, setSelectedActionOption] =
    useState<string>("notChosen");
  const [selectedCheckTypeOption, setSelectedCheckTypeOption] =
    useState<string>("DISTANCE");
  const [selectedDeliveryOption, setSelectedDeliveryOption] =
    useState<string>("OnTime");
  const [selectedRateStatusOption, setSelectedRateStatusOption] =
    useState<string>("NotChecked");
  const [selectedReviewStatusOption, setSelectedReviewStatusOption] =
    useState<string>("NotChecked");
  const [selectedReviewReasonId, setSelectedReviewReasonId] =
    useState<any>(null);
  const [reportCheckCommentValue, setReportCheckCommentValue] =
    useState<string>("");
  const [selectedReportCheckReasons, setSelectedReportCheckReasons] = useState<
    string[]
  >([]);
  const [isButtonName, setIsButtonName] = useState<string>("Принять");
  const [selectedReportsSettings, setSelectedReportsSettings] = useState<
    string[]
  >(data?.isCustomer ? reportsSettings : adminReportsSettings);
  const [selectedEmployeesListSettings, setSelectedEmployeesListSettings] =
    useState<string[]>(employeesListSettings);
  const [selectedFiredListSettings, setSelectedFiredListSettings] =
    useState<string[]>(firedListSettings);
  const [selectedExpiredReportsSettings, setSelectedExpiredReportsSettings] =
    useState<string[]>(expiredReportsSettings);
  const [selectedRoutesSettings, setSelectedRoutesSettings] =
    useState<string[]>(routesSettings);
  const [selectedVacantRoutesSettings, setSelectedVacantRoutesSettings] =
    useState<string[]>(vacantRoutesSettings);
  const [selectedVacancyListSettings, setSelectedVacancyListSettings] =
    useState<string[]>(vacancyListSettings);
  const [selectedChartsSettings, setSelectedChartsSettings] = useState<
    string[]
  >([]);
  const [isPageId, setIsPageId] = useState<number | null>(null);
  const [isCheckedFullInfo, setIsCheckedFullInfo] = useState<boolean>(
    (data?.isCustomer
      ? JSON.parse(localStorage.getItem("isSelectedAllTabs") as string)
      : JSON.parse(localStorage.getItem("isSelectedAllAdminTabs") as string)) ||
      false
  );
  const [isCheckedAllSettings, setIsCheckedAllSettings] = useState<boolean>(
    (data?.isCustomer
      ? JSON.parse(localStorage.getItem("isSelectedAllSettings") as string)
      : JSON.parse(
          localStorage.getItem("isSelectedAllAdminSettings") as string
        )) || false
  );

  const [isCheckedAllExpiredSettings, setIsCheckedAllExpiredSettings] =
    useState<boolean>(
      JSON.parse(
        localStorage.getItem("isSelectedAllExpiredSettings") as string
      ) || false
    );

  const [isCheckedAllRoutesSettings, setIsCheckedAllRoutesSettings] =
    useState<boolean>(
      JSON.parse(
        localStorage.getItem("isSelectedAllRoutesSettings") as string
      ) || false
    );

  const [
    isCheckedAllVacantRoutesSettings,
    setIsCheckedAllVacantRoutesSettings,
  ] = useState<boolean>(
    JSON.parse(
      localStorage.getItem("isSelectedAllVacantRoutesSettings") as string
    ) || false
  );

  const [isCheckedAllVacancyListSettings, setIsCheckedAllVacancyListSettings] =
    useState<boolean>(
      JSON.parse(
        localStorage.getItem("isSelectedAllVacancyListSettings") as string
      ) || false
    );

  const [
    isCheckedAllEmployeesListSettings,
    setIsCheckedAllEmployeesListSettings,
  ] = useState<boolean>(
    JSON.parse(
      localStorage.getItem("isSelectedAllEmployeesSettings") as string
    ) || false
  );
  const [isCheckedAllFiredListSettings, setIsCheckedAllFiredListSettings] =
    useState<boolean>(
      JSON.parse(
        localStorage.getItem("isSelectedAllFiredSettings") as string
      ) || false
    );

  const [isCheckedAllChartsSettings, setIsCheckedAllChartsSettings] =
    useState<boolean>(() => {
      const storedValue = localStorage.getItem("selectedChartsTabs");
      return storedValue ? JSON.parse(storedValue).length > 5 : false;
    });

  const [selectedReportTabs, setSelectedReportTabs] = useState<string[]>(
    data?.isCustomer ? settings : adminSettings
  );
  const [selectedCustomServices, setSelectedCustomServices] = useState<any>([]);
  const [reorderedReportOptions, setReorderedReportOptions] = useState<any>([]);
  const [reviewReasonError, setReviewReasonError] = useState<string>("");
  const [reportCheckError, setReportCheckError] = useState<string>("");
  const [selectedActions, setSelectedActions] = useState<any>([]);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [reportLimit, setReportLimit] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [withGeolocations, setWithGeolocations] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [isNewDesktopName, setIsNewDesktopName] = useState<string>("");
  const [isClickRejectBtn, setIsClickRejectBtn] = useState<boolean>(false);
  const [isHasShadowList, setIsHasShadowList] = useState<string[]>([]);

  const [printRef, setPrintRef] = useState<any>(null);

  const arrType = ["ON_ROUTE", "PARTIAL_ROUTE"];

  const settingsActions: any = {
    singleReportSettings: {
      reducer: reducerSelectedReportSettings,
      selectedTabsKey: "selectedTabs",
      selectedTabs: selectedReportTabs,
      allTabsKey: "isSelectedAllTabs",
      allTabs: isCheckedFullInfo,
      reorderAction: () => {
        dispatch(
          actionSetSingleReportSettings(
            "customerReport",
            reorderedReportOptions
          )
        );
        dispatch(
          reducerSingleReportSettingsOptions({ entity: reorderedReportOptions })
        );
      },
    },
    adminSingleReportSettings: {
      reducer: reducerSelectedAdminReportSettings,
      selectedTabsKey: "selectedTabs",
      selectedTabs: selectedReportTabs,
      allTabsKey: "isSelectedAllAdminTabs",
      allTabs: isCheckedFullInfo,
      reorderAction: () => {
        dispatch(
          actionSetSingleReportSettings("adminReport", reorderedReportOptions)
        );
        dispatch(
          reducerSingleReportSettingsOptions({ entity: reorderedReportOptions })
        );
      },
    },
    customerReportsSettings: {
      reducer: reducerReportsSettings,
      selectedTabsKey: "selectedReportsTabs",
      selectedTabs: selectedReportsSettings,
      allTabsKey: "isSelectedAllSettings",
      allTabs: isCheckedAllSettings,
    },
    adminReportsSettings: {
      reducer: reducerAdminReportsSettings,
      selectedTabsKey: "selectedAdminReportsTabs",
      selectedTabs: selectedReportsSettings,
      allTabsKey: "isSelectedAllAdminSettings",
      allTabs: isCheckedAllSettings,
    },
    expiredReportsSettings: {
      reducer: reducerExpiredReportsSettings,
      selectedTabsKey: "selectedExpiredReportsTabs",
      selectedTabs: selectedExpiredReportsSettings,
      allTabsKey: "isSelectedAllExpiredSettings",
      allTabs: isCheckedAllExpiredSettings,
    },
    routesSettings: {
      reducer: reducerRoutesSettings,
      selectedTabsKey: "selectedRoutesTabs",
      selectedTabs: selectedRoutesSettings,
      allTabsKey: "isSelectedAllRoutesSettings",
      allTabs: isCheckedAllRoutesSettings,
    },
    vacantRoutesSettings: {
      reducer: reducerVacantRoutesSettings,
      selectedTabsKey: "selectedVacantRoutesTabs",
      selectedTabs: selectedVacantRoutesSettings,
      allTabsKey: "isSelectedAllVacantRoutesSettings",
      allTabs: isCheckedAllVacantRoutesSettings,
    },
    vacancyListSettings: {
      reducer: reducerVacancyListSettings,
      selectedTabsKey: "selectedVacancyListTabs",
      selectedTabs: selectedVacancyListSettings,
      allTabsKey: "isSelectedAllVacancyListSettings",
      allTabs: isCheckedAllVacancyListSettings,
    },
    employeesListSettings: {
      reducer: reducerEmployeesListSettings,
      selectedTabsKey: "selectedEmployeesListTabs",
      selectedTabs: selectedEmployeesListSettings,
      allTabsKey: "isSelectedAllEmployeesListSettings",
      allTabs: isCheckedAllEmployeesListSettings,
    },
    firedListSettings: {
      reducer: reducerFiredEmployeesListSettings,
      selectedTabsKey: "selectedFiredListTabs",
      selectedTabs: selectedFiredListSettings,
      allTabsKey: "isSelectedAllFiredListSettings",
      allTabs: isCheckedAllFiredListSettings,
    },
    chartsSettings: {
      reducer: reducerDesktopSetting,
      selectedTabsKey: "selectedChartsTabs",
      selectedTabs: selectedChartsSettings,
      allTabsKey: "isSelectedAllChartstSettings",
      allTabs: isCheckedAllChartsSettings,
    },
  };

  const closeActions: any = {
    reportCheck: () => {
      setSelectedActionOption("acceptReport");
      setSelectedCheckTypeOption("DISTANCE");
      setSelectedReportCheckReasons([]);
      setReportCheckCommentValue("");
    },
    updateDeliveryStatus: () => {
      setSelectedDeliveryOption("OnTime");
    },
    updateRateStatus: () => {
      setSelectedRateStatusOption("NotChecked");
    },
    updateReviewStatus: () => {
      setSelectedReviewStatusOption("NotChecked");
      setSelectedReviewReasonId(null);
      setReviewReasonError("");
    },
    customerReportsSettings: () => {
      setSelectedReportsSettings(reportsSettings);
      setIsCheckedAllSettings(
        JSON.parse(localStorage.getItem("isSelectedAllSettings") as string) ||
          false
      );
    },
    adminReportsSettings: () => {
      setSelectedReportsSettings(adminReportsSettings);
      setIsCheckedAllSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllAdminSettings") as string
        ) || false
      );
    },
    expiredReportsSettings: () => {
      setSelectedExpiredReportsSettings(expiredReportsSettings);
      setIsCheckedAllExpiredSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllExpiredSettings") as string
        ) || false
      );
    },
    RoutesSettings: () => {
      setSelectedRoutesSettings(routesSettings);
      setIsCheckedAllRoutesSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllRoutesSettings") as string
        ) || false
      );
    },
    VacantRoutesSettings: () => {
      setSelectedVacantRoutesSettings(vacantRoutesSettings);
      setIsCheckedAllVacantRoutesSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllVacantRoutesSettings") as string
        ) || false
      );
    },
    VacancyListSettings: () => {
      setSelectedVacancyListSettings(vacancyListSettings);
      setIsCheckedAllVacancyListSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllVacancyListSettings") as string
        ) || false
      );
    },
    singleReportSettings: () => {
      setSelectedReportTabs(settings);
      setIsCheckedFullInfo(
        JSON.parse(localStorage.getItem("isSelectedAllTabs") as string) || false
      );
    },
    adminSingleReportSettings: () => {
      setSelectedReportTabs(adminSettings);
      setIsCheckedFullInfo(
        JSON.parse(localStorage.getItem("isSelectedAllAdminTabs") as string) ||
          false
      );
    },
    employeesListSettings: () => {
      setSelectedEmployeesListSettings(employeesListSettings);
      setIsCheckedAllEmployeesListSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllEmployeesListSettings") as string
        ) || false
      );
    },
    firedListSettings: () => {
      setSelectedFiredListSettings(firedListSettings);
      setIsCheckedAllFiredListSettings(
        JSON.parse(
          localStorage.getItem("isSelectedAllFiredListSettings") as string
        ) || false
      );
    },
  };

  const handleClickApplyBtn = () => {
    if (actualPurpose === "skuUnload") {
      dispatch(actionExportTanderProducts());
      setOpen(false);
      return;
    }

    if (actualPurpose === "signalsDownload") {
      dispatch(actionExportSignals());
      setOpen(false);
      return;
    }

    if (actualPurpose === "navigateToVacancyList") {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get("source");
      inputValues.type && navigate(source || "/recruiting/vacancy");
    }

    if (actualPurpose === "navigateToEmployeesList") {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get("source");
      navigate(source || "/employees");
    }

    if (actualPurpose === "navigateToProjectsList") {
      navigate(`/projects`);
    }

    if (actualPurpose === "navigateToContractsList") {
      navigate(`/contracts`);
    }

    if (actualPurpose === "navigateToApplicationsList") {
      navigate(`/recruiting/applicationform`);
    }

    if (actualPurpose === "addChart") {
      dispatch(reducerAddCharts(selectChartsType));
      dispatch(reducerNewCharts({ id: id || "0", charts: selectChartsType }));
      dispatch(actionAddDesktop());
    }

    if (actualPurpose === "saveApplication") {
      let errors = [];
      if (!applicationInputValues.applicantStatus) {
        errors.push("status");
      }
      if (!applicationInputValues.firstName) {
        errors.push("firstName");
      }
      if (!applicationInputValues.lastName) {
        errors.push("lastName");
      }
      if (!applicationInputValues.gender) {
        errors.push("gender");
      }
      if (errors.length === 0) {
        const obj = {
          application: application.application,
          ...applicationInputValues,
        };
        dispatch(actionCreateApplication(obj));
      } else {
        dispatch(reducerSingleApplicationErrors(errors));
      }
    }

    if (actualPurpose === "addRouteOnVacancy") {
      dispatch(reducerSetPending(true));
      const updateRoutes = inputValues?.routes?.length
        ? vacantCheckboxesList.map((obj1: IRoutesOptions) => {
            const obj2 = inputValues.routes.find(
              (elem: IProjectOptions) => elem.project.id === obj1.project.id
            );
            if (obj2) {
              const updatedRoutes = obj2.routes.concat(obj1.routeNo);
              return { ...obj2, routes: updatedRoutes };
            } else {
              return { project: obj1.project, routes: [obj1.routeNo] };
            }
          })
        : [];

      const newRoutes = inputValues.routes
        ? inputValues?.routes.concat(updateRoutes)
        : dataForProjectRoutesCheckboxes(vacantCheckboxesList);
      const newProjects = inputValues.projects.concat(
        vacantCheckboxesList.map((el: IProjectOptions) => el.project)
      );
      dispatch(
        actionUpdateVacancy({
          ...inputValues,
          routes: newRoutes,
          projects: newProjects,
        })
      )
        .then((res: any) => {
          if (res.status === 200) {
            dispatch(reducerGetVacantRoutes({ data: [] }));
            dispatch(reducerSingleVacancyStatus(res.status));
            dispatch(
              reducerSingleVacancyStatusMessage("Маршрут успешно добавлен")
            );
            dispatch(reducerSetPending(false));
            dispatch(reducerVacantRoutesInputValues({ project: null }));
          } else if (res?.response?.status === 400) {
            dispatch(reducerSingleVacancyStatus(res?.response?.status));
            dispatch(
              reducerSingleVacancyStatusMessage(
                formatErrorMessage(res?.response?.data)
              )
            );
          } else {
          }
        })
        .then(() => {});
    }
    if (actualPurpose === "removeSelections") {
      const vacancyId = inputValues?.vacancy?.id;
      dispatch(actionRemoveSelections(vacancyId));
    }

    if (actualPurpose === "deleteRoute") {
      const noCheckedItems =
        vacantCheckboxesNoModule &&
        vacantCheckboxesNoModule.filter(
          (item: IRoutesOptions) => !item.checked
        );
      const CheckedItems =
        vacantCheckboxesNoModule &&
        vacantCheckboxesNoModule.filter((item: IRoutesOptions) => item.checked);
      if (!CheckedItems || !CheckedItems.length) {
        dispatch(
          reducerSingleVacancyStatusMessage("Не выбран ни один маршрут")
        );
        dispatch(reducerSingleVacancyStatus(400));
      } else {
        const updatedInputValues = { ...inputValues };
        if (!noCheckedItems.length) {
          updatedInputValues.type = "LOST_ROUTE";
          delete updatedInputValues.routes;
        } else {
          const projectRoutes = dataForCreateVacancyModal(
            noCheckedItems,
            inputValues.projects
          );
          const newRoutes = projectRoutes.filter(
            (el: IProjectOptions) => el.routes.length > 0
          );
          updatedInputValues.routes = newRoutes;
          updatedInputValues.projects = newRoutes.map(
            (el: IProjectOptions) => el.project
          );
        }
        dispatch(actionUpdateVacancy(updatedInputValues)).then((res: any) => {
          dispatch(reducerGetVacantRoutes({ data: [] }));
          dispatch(reducerClearInputValuesNoModal());
          dispatch(reducerGetSingleVacancy(res.data));
          dispatch(reducerSingleVacancyStatusMessage("Маршрут успешно удален"));
          dispatch(reducerSingleVacancyStatus(200));
        });
      }
    }

    if (actualPurpose === "createVacancyVacantRoutes") {
      if (
        (!arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.projects) ||
        (arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.routesNo)
      ) {
        setDisabledButton(true);
        dispatch(
          actionCreateVacancy(vacancyCreateInputValues, "4", navigate)
        ).then(() => {
          setDisabledButton(false);
        });
      } else {
        const errors = [];
        if (!vacancyCreateInputValues.type) {
          errors.push("errorType");
        }
        if (!vacancyCreateInputValues.projects) {
          errors.push("errorProject");
          dispatch(reducerVacantRoutesStatus(2));
        }
        if (
          vacancyCreateInputValues.projects &&
          arrType.includes(vacancyCreateInputValues.type) &&
          !vacancyCreateInputValues.routesNo
        ) {
          errors.push("errorRoutesNo");
          dispatch(reducerVacantRoutesStatus(3));
        }
        dispatch(reducerHandleErrors(errors));
        return console.log("errors");
      }
    }
    if (actualPurpose === "createVacancyVacant") {
      if (
        (!arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.projects) ||
        (arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.routesNo)
      ) {
        setDisabledButton(true);
        dispatch(
          actionCreateVacancy(vacancyCreateInputValues, "1", navigate)
        ).then(() => {
          handleClickCloseBtn();
          setDisabledButton(false);
        });
      } else {
        const errors = [];
        if (!vacancyCreateInputValues.type) {
          errors.push("errorType");
        }
        if (!vacancyCreateInputValues.projects) {
          errors.push("errorProject");
          dispatch(reducerVacancyStatus(2));
        }
        if (
          vacancyCreateInputValues.projects &&
          arrType.includes(vacancyCreateInputValues.type) &&
          !vacancyCreateInputValues.routesNo
        ) {
          errors.push("errorRoutesNo");
          dispatch(reducerVacancyStatus(3));
        }
        dispatch(reducerHandleErrors(errors));
        return console.log("errors");
      }
    }
    if (actualPurpose === "createVacancyRoutes") {
      if (
        (!arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.projects) ||
        (arrType.includes(vacancyCreateInputValues.type) &&
          vacancyCreateInputValues.routesNo)
      ) {
        setDisabledButton(true);
        dispatch(
          actionCreateVacancy(vacancyCreateInputValues, "2", navigate)
        ).then(() => {
          handleClickCloseBtn();
          setDisabledButton(false);
        });
      } else {
        const errors: string[] = [];
        if (!vacancyCreateInputValues.type) {
          errors.push("errorType");
        }
        if (!vacancyCreateInputValues.projects) {
          errors.push("errorProject");
          dispatch(reducerRoutesStatus(2));
        }
        if (
          vacancyCreateInputValues.projects &&
          arrType.includes(vacancyCreateInputValues.type) &&
          !vacancyCreateInputValues.routesNo
        ) {
          errors.push("errorRoutesNo");
          dispatch(reducerRoutesStatus(3));
        }
        dispatch(reducerHandleErrors(errors));
        return console.log(errors);
      }
    }

    if (actualPurpose === "outletsDownload") {
      selectedFiles.length &&
        dispatch(actionImportPos(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }

    if (actualPurpose === "UnloadData") {
      if (selectedVacanciesId.length > 0) {
        const arrayId = selectedVacanciesId.map(
          (item: { id: number }) => item.id
        );
        dispatch(actionVacanciesExport(arrayId, data?.email));
      } else {
        dispatch(reducerVacancyStatus(400));
        dispatch(reducerVacancyStatusMessage("Не выбрана ни одна вакансия"));
      }
    }

    if (actualPurpose === "createExpiredReports") {
      dispatch(actionCreateExpiredReports(reportsId));
    }

    if (settingsActions.hasOwnProperty(actualPurpose)) {
      if (actualPurpose === "chartsSettings") {
        const { reorderAction, selectedTabs, reducer } =
          settingsActions[actualPurpose];

        reorderAction && reorderAction();
        dispatch(
          reducer({
            id: isPageId,
            value: selectedTabs,
            order: reorderedReportOptions,
          })
        );
        dispatch(actionAddDesktop());
      } else {
        const {
          selectedTabsKey,
          reorderAction,
          selectedTabs,
          allTabsKey,
          reducer,
          allTabs,
        } = settingsActions[actualPurpose];

        localStorage.setItem(
          allTabsKey,
          JSON.stringify(allTabs ? true : false)
        );
        localStorage.setItem(selectedTabsKey, JSON.stringify(selectedTabs));

        reorderAction && reorderAction();
        dispatch(reducer(selectedTabs));
      }
    }

    if (actualPurpose === "errorsUnload") {
      dispatch(actionUnloadIntegrationErrors(0));
    }

    if (actualPurpose === "outletsUnload") {
      dispatch(actionUnloadOutlets(limit, offset, outletsInputValues));
    }

    if (copyActions.hasOwnProperty(actualPurpose)) {
      const action = copyActions[actualPurpose];

      dispatch(
        action({
          reports:
            actualPurpose === "copyReport"
              ? [
                  {
                    id: report && report.reportId.id,
                  },
                ]
              : selectedReportsId,
          date: !selectedDate
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(selectedDate).format("YYYY-MM-DD"),
          withGeolocations: withGeolocations,
        })
      ).then(() => {
        dispatch(actionGetUserReports(limit, page));
      });
    }

    if (actualPurpose === "updateDeliveryStatus") {
      dispatch(
        actionUpdateDeliveryStatus({
          reports: selectedReportsId.map((report: { id: number }) => {
            return {
              id: report.id,
              name: "",
            };
          }),
          deliveryStatus: selectedDeliveryOption,
        })
      );
      dispatch(reducerSelectedUpdateStatus(selectedDeliveryOption));
      setSelectedDeliveryOption("OnTime");
    }

    if (actualPurpose === "deletePhotos") {
      if (photos && photos.length) {
        dispatch(
          actionDeleteReportPhotos({
            reportId: report && report.reportId.id,
            medias: [
              photos.map((photoId: number) => {
                return {
                  id: photoId,
                };
              }),
            ],
          })
        );
        dispatch(reducerDeletePhotosId([]));
      }
    }

    if (actualPurpose === "deleteExpired") {
      dispatch(actionDeleteExpiredReports(reportsId));
    }

    if (actualPurpose === "deleteReport") {
      dispatch(actionDeleteReport(report && report.reportId.id)).then(() => {
        navigate("/reports");
      });
    }

    if (actualPurpose === "applicationCreate") {
      dispatch(actionCreateApplication(applicationCreateIV)).then(() => {
        navigate("/recruiting/applicationform");
      });
    }

    if (actualPurpose === "vacancyUpdate") {
      if (!inputValues.name) {
        dispatch(reducerSingleVacancyStatus(400));
        dispatch(
          reducerSingleVacancyStatusMessage("Заполните поле название вакансии")
        );
      } else {
        const newValues = { ...inputValues };
        delete newValues.projectRoutes;
        dispatch(actionUpdateVacancy(newValues)).then((res: any) => {
          if (res.status === 200) {
            dispatch(reducerSingleVacancyStatus(res.status));
            dispatch(
              reducerSingleVacancyStatusMessage("Вакансия успешно обновлена")
            );
            dispatch(reducerSetPending(false));
          } else if (res?.response?.status === 400) {
            dispatch(reducerSingleVacancyStatus(res?.response?.status));
            dispatch(
              reducerSingleVacancyStatusMessage(
                formatErrorMessage(res?.response?.data)
              )
            );
          } else {
          }
        });
      }
    }
    if (actualPurpose === "createVacancy") {
      if (vacancyCreateInputValues.type && vacancyCreateInputValues.project) {
        dispatch(actionCreateVacancy({ ...vacancyCreateInputValues }, "3"));
      } else {
        const errors = [];
        if (!vacancyCreateInputValues.type) {
          errors.push("errorType");
        }
        if (!vacancyCreateInputValues.project) {
          errors.push("errorProject");
        }
        dispatch(reducerHandleErrors(errors));
      }
    }
    if (actualPurpose === "newApplication") {
      let obj = {};
      if (application.application) {
        obj = {
          // @ts-ignore
          application: application.application,
        };
      }
      if (selectedVacancy?.vacancy?.id) {
        obj = {
          ...obj,
          // @ts-ignore
          vacancy: {
            id: selectedVacancy?.vacancy?.id,
          },
        };
      }
      obj = {
        ...obj,
        applicantStatus: "NEW",
        gender: "Male",
        ...applicationData,
      };
      dispatch(actionCreateApplication(obj)).then((res: any) => {
        navigate(`/recruiting/applicationform/${res.data.application.id}`);
        window.location.reload();
      });
    }

    if (actualPurpose === "createGeo") {
      if (!!selectedReportsId.length) {
        try {
            dispatch(actionCreateGeo(selectedReportsId)).then(() => {
              dispatch(
                reducerReportsStatus({
                  reportsStatus: 200,
                  reportsRequestPurpose: "createGeo",
                })
              );
            });
          } catch (err) {
            dispatch(
              reducerReportsStatus({
                reportsStatus: 0,
                reportsRequestPurpose: "createGeo",
              })
            );
          }
      }
    }

      if (actualPurpose === "consolidatedBudgeExport") {
          try {
              dispatch(actionConsolidatedBudgeCreate(selectedProjectsId || [])).then(() => {
                  dispatch(reducerConsolidatedBudgetStatus({reportsStatus: 200}));
              });
          } catch (err) {
              dispatch(reducerConsolidatedBudgetStatus({reportsStatus: 0}));
          }
      }

    if (actualPurpose === "updateRateStatus") {
      if (
        !!selectedReportsId.length &&
        selectedRateStatusOption === "NotChecked"
      ) {
        const filteredSelectedReports = selectedReportsId.filter(
          (elem: { id: number }) =>
            reports.find(
              (report: IReportsOptions) => report.reportId === elem.id
            ).rateStatus !== "NotChecked"
        );

        if (!!filteredSelectedReports.length) {
          filteredSelectedReports.forEach(
            (reportId: { id: number }, index: number) => {
              const isLastRequest =
                index === filteredSelectedReports.length - 1;

              dispatch(
                actionCancelReportClaim({
                  reportId: {
                    id: reportId.id,
                    name: "",
                  },
                })
              ).then(() => {
                if (isLastRequest) {
                  dispatch(
                    reducerReportsStatus({
                      reportsStatus: 200,
                      reportsRequestPurpose: "updateRateStatus",
                    })
                  );
                }
              });
            }
          );
        } else {
          dispatch(
            reducerReportsStatus({
              reportsStatus: 0,
              reportsRequestPurpose: "updateRateStatus",
            })
          );
          dispatch(reducerSelectedReports([]));
        }
      } else if (
        !!selectedReportsId.length &&
        selectedRateStatusOption === "Accepted"
      ) {
        const filteredSelectedReports = selectedReportsId.filter(
          (elem: { id: number }) =>
            reports.find(
              (report: IReportsOptions) => report.reportId === elem.id
            ).rateStatus !== "Accepted"
        );

        if (!!filteredSelectedReports.length) {
          filteredSelectedReports.forEach(
            (reportId: { id: number }, index: number) => {
              const isLastRequest =
                index === filteredSelectedReports.length - 1;

              dispatch(
                actionClientAcceptReport({
                  reportId: {
                    id: reportId.id,
                    name: "",
                  },
                  rateNote: "",
                  weigth: 0,
                })
              ).then(() => {
                if (isLastRequest) {
                  dispatch(
                    reducerReportsStatus({
                      reportsStatus: 200,
                      reportsRequestPurpose: "updateRateStatus",
                    })
                  );
                }
              });
            }
          );
        } else {
          dispatch(
            reducerReportsStatus({
              reportsStatus: 0,
              reportsRequestPurpose: "updateRateStatus",
            })
          );
          dispatch(reducerSelectedReports([]));
        }
      } else if (
        !!selectedReportsId.length &&
        selectedRateStatusOption === "Declined"
      ) {
        const filteredSelectedReports = selectedReportsId.filter(
          (elem: { id: number }) => {
            const actualReport = reports.find(
              (report: IReportsOptions) => report.reportId === elem.id
            ).rateStatus;

            return (
              actualReport !== "Declined" &&
              actualReport !== "PartiallyDeclined"
            );
          }
        );

        if (!!filteredSelectedReports.length) {
          filteredSelectedReports.forEach(
            (reportId: { id: number }, index: number) => {
              const isLastRequest =
                index === filteredSelectedReports.length - 1;

              dispatch(
                actionDeclineRate({
                  reportId: {
                    id: reportId.id,
                    name: "",
                  },
                  rateNote: "",
                  weigth: 0,
                })
              ).then(() => {
                if (isLastRequest) {
                  dispatch(
                    reducerReportsStatus({
                      reportsStatus: 200,
                      reportsRequestPurpose: "updateRateStatus",
                    })
                  );
                }
              });
            }
          );
        } else {
          dispatch(
            reducerReportsStatus({
              reportsStatus: 0,
              reportsRequestPurpose: "updateRateStatus",
            })
          );
          dispatch(reducerSelectedReports([]));
        }
      }

      dispatch(reducerSelectedUpdateStatus(selectedRateStatusOption));
      setSelectedRateStatusOption("NotChecked");
    }

    if (actualPurpose === "updateReviewStatus") {
      if (
        !!selectedReportsId.length &&
        selectedReviewStatusOption === "NotChecked"
      ) {
        const filteredSelectedReports = selectedReportsId.filter(
          (elem: { id: number }) =>
            reports.find(
              (report: IReportsOptions) => report.reportId === elem.id
            ).reviewStatus !== "NotChecked"
        );
        if (!!filteredSelectedReports.length) {
          filteredSelectedReports.forEach(
            (reportId: { id: string }, index: number) => {
              const isLastRequest =
                index === filteredSelectedReports.length - 1;

              dispatch(actionCancelReportReview(reportId.id)).then(() => {
                if (isLastRequest) {
                  dispatch(
                    reducerReportsStatus({
                      reportsStatus: 200,
                      reportsRequestPurpose: "updateReviewStatus",
                    })
                  );
                }
              });
            }
          );
        } else {
          dispatch(
            reducerReportsStatus({
              reportsStatus: 0,
              reportsRequestPurpose: "updateReviewStatus",
            })
          );
          dispatch(reducerSelectedReports([]));
        }
      } else if (
        !!selectedReportsId.length &&
        selectedReviewStatusOption === "Approved"
      ) {
        selectedReportsId.forEach((reportId: { id: number }, index: number) => {
          const isLastRequest = index === selectedReportsId.length - 1;

          dispatch(
            actionApproveReport({
              reportId: {
                id: reportId.id,
                name: "",
              },
              reviewComment: "",
              comment: "",
            })
          ).then(() => {
            if (isLastRequest) {
              dispatch(
                reducerReportsStatus({
                  reportsStatus: 200,
                  reportsRequestPurpose: "updateReviewStatus",
                })
              );
            }
          });
        });
      } else if (
        !!selectedReportsId.length &&
        selectedReviewStatusOption === "Rejected"
      ) {
        if (!selectedReviewReasonId) {
          setReviewReasonError("Нужно указать причину прежде, чем продолжить");
          return;
        } else {
          selectedReportsId.forEach(
            (reportId: { id: number }, index: number) => {
              const isLastRequest = index === selectedReportsId.length - 1;
              dispatch(
                actionRejectReport({
                  reportId: {
                    id: reportId.id,
                    name: "",
                  },
                  reviewReasonId: {
                    id: selectedReviewReasonId,
                  },
                  reviewComment: "",
                  comment: "",
                })
              ).then(() => {
                if (isLastRequest) {
                  dispatch(
                    reducerReportsStatus({
                      reportsStatus: 200,
                      reportsRequestPurpose: "updateReviewStatus",
                    })
                  );
                }
              });
            }
          );
        }
      } else if (
        !!selectedReportsId.length &&
        selectedReviewStatusOption === "Revision"
      ) {
        if (!selectedReviewReasonId) {
          setReviewReasonError("Нужно указать причину прежде, чем продолжить");
          return;
        } else {
          const filteredSelectedReports = selectedReportsId.filter(
            (elem: { id: number }) =>
              reports.find(
                (report: IReportsOptions) => report.reportId === elem.id
              ).reviewStatus !== "Revision"
          );

          if (!!filteredSelectedReports.length) {
            filteredSelectedReports.forEach(
              (reportId: { id: number }, index: number) => {
                const isLastRequest =
                  index === filteredSelectedReports.length - 1;

                dispatch(
                  actionRevisionReport({
                    reportId: {
                      id: reportId.id,
                      name: "",
                    },
                    reviewReasonId: {
                      id: selectedReviewReasonId,
                    },
                    reviewComment: "",
                    comment: "",
                    customReason: "",
                  })
                ).then(() => {
                  if (isLastRequest) {
                    dispatch(
                      reducerReportsStatus({
                        reportsStatus: 200,
                        reportsRequestPurpose: "updateReviewStatus",
                      })
                    );
                  }
                });
              }
            );
          } else {
            dispatch(
              reducerReportsStatus({
                reportsStatus: 0,
                reportsRequestPurpose: "updateReviewStatus",
              })
            );
            dispatch(reducerSelectedReports([]));
          }
        }
      }

      dispatch(reducerSelectedUpdateStatus(selectedReviewStatusOption));
      setSelectedReviewStatusOption("NotChecked");
      setSelectedReviewReasonId(null);
    }

    if (actualPurpose === "reportCheck") {
      if (
        selectedActionOption === "acceptReport" ||
        selectedActionOption === "notChosen"
      ) {
          if ((selectedReportCheckReasons?.length > 0)) {
              const isCommentRequired = list?.filter((o: IReportCriteriasOptions) =>
                                                         o.rateAcceptNote && selectedReportCheckReasons.includes(o.reason.id.toString()))?.length > 0;
              if (isCommentRequired && reportCheckCommentValue === "") {
                  setReportCheckError("notes");
                  return;
              }
          }
        dispatch(
          actionAcceptRate(
            {
              reportId: {
                id: report && report?.reportId.id,
              },
              ...(selectedReportCheckReasons.length > 0 && {
                reviewReasons: selectedReportCheckReasons.map(
                  (value: string) => {
                    return {
                      id: parseFloat(value),
                    };
                  }
                ),
              }),
              ...(reportCheckCommentValue !== "" && {
                rateNote: reportCheckCommentValue,
              }),
              checkType: selectedCheckTypeOption,
            },
            "reportCheckBtn"
          )
        );
        return;
      } else if (
        selectedActionOption === "formClaim" ||
        selectedActionOption === "formRecommendation"
      ) {
        if (reportCheckCommentValue === "") {
          setReportCheckError("notes");
          return;
        }

        if (!selectedReportCheckReasons.length) {
          setReportCheckError("reasons");
          return;
        }

        if (reportCheckCommentValue && !!selectedReportCheckReasons.length) {
          dispatch(
            actionClientRequestReport(
              {
                reportId: {
                  id: report && report.reportId.id,
                },
                reviewReasons: selectedReportCheckReasons.map(
                  (value: string) => {
                    return {
                      id: parseFloat(value),
                    };
                  }
                ),
                notes: reportCheckCommentValue,
                checkType: selectedCheckTypeOption,
                claimType:
                  selectedActionOption === "formClaim"
                    ? "Claim"
                    : "Recommendation",
              },
              selectedFiles,
              "reportCheckBtn"
            )
          );
        }
      }
    }
    if (actualPurpose === "deleteUsersClaims") {
      dispatch(actionEditVisibleEmployees(selectedUserId, false)).then(() => {
        dispatch(actionTableEmployeesList(limit, 1, true));
      });
    }
    if (actualPurpose === "newUsersClaims") {
      dispatch(actionEditVisibleEmployees(selectedUserId, true)).then(() => {
        dispatch(actionTableEmployeesList(limit, 1, true));
        dispatch(reducerClearFilters());
      });
    }
    if (unloadActions.hasOwnProperty(actualPurpose)) {
      if (reportLimit === "") {
        setError("Вы должны указать значение лимита выгрузки");
        return;
      } else {
        const action = unloadActions[actualPurpose];
        if (actualPurpose === "unloadReportsTander") {
          dispatch(
            actionGetEmployeesListConditional({
              ...reportsInputValues,
              limit: parseFloat(reportLimit),
              page: 1,
            })
          );
          setError("");
          setOpen(false);
          return;
        }
        if (actualPurpose === "unloadExpiredList") {
          dispatch(action(parseFloat(reportLimit)));
        } else if (actualPurpose === "unloadReportsPhotos") {
          dispatch(
            action({
              customServices: selectedCustomServices,
              actions: selectedActions,
              reportFilter: {
                ...reportsInputValues,
                limit: parseFloat(reportLimit),
                page: 1,
              },
            })
          );
        } else {
          dispatch(
            action({
              ...reportsInputValues,
              limit: parseFloat(reportLimit),
              page: 1,
            })
          );
        }

        setError("");
      }
    }
    if (actualPurpose === "lostVacancyRoutes") {
      dispatch(
        reducerSingleVacancyIV({
          ...inputValues,
          editType: false,
        })
      );
      dispatch(
        reducerHeaderBtn({
          purpose: "lostVacancyRoutes",
          title: "Смена типа вакансии.",
          openModal: false,
        })
      );
    }
    if (actualPurpose === "createReports") {
      selectedFiles.length &&
        dispatch(actionImportReport(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    if (actualPurpose === "uploadKPI") {
      selectedFiles.length &&
        dispatch(actionImportReportKPI(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    if (actualPurpose === "changeShiftStart") {
      if (id && selectedFiles) {
        dispatch(actionUploadStartShift(id, selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
      }
    }
    if (actualPurpose === "changeEmployeePay") {
      console.log(employeeStatus);
    }
    if (actualPurpose === "fireAnEmployee") {
      console.log(employeeStatus);
    }
    if (actualPurpose === "editDesktop") {
      if (isNewDesktopName !== "") {
        setDisabledButton(false);
        const findItem = desktopList.find((el: any) => el.id.toString() === id);
        if (findItem && findItem.name !== isNewDesktopName) {
          dispatch(reducerEditDesktop({ id, name: isNewDesktopName }));
          dispatch(actionAddDesktop());
        }
      } else {
        setDisabledButton(true);
      }
    }
    if (actualPurpose === "addDesktop") {
      if (isNewDesktopName !== "") {
        const nextId =
          Math.max(...desktopList.map((item: any) => item.id), 0) + 1;
        const newChartsList = [
          ...(desktopList || []),
          { list: [], id: nextId, name: isNewDesktopName },
        ];
        dispatch(reducerDesktopName(newChartsList));
        dispatch(actionAddDesktop());
        navigate(`/charts/${nextId}`);
      }
    }
    if (actualPurpose === "deleteDesktop") {
      const newChartsList = desktopList.filter((el: any) =>
        id ? el.id.toString() !== id : el.id !== 0
      );
      dispatch(reducerDesktopName(newChartsList));
      dispatch(actionAddDesktop());
      setIsClickRejectBtn(false);
      handleClickCloseBtn();
      if (newChartsList[0]) {
        navigate(`/charts/${newChartsList[0].id}`);
      } else {
        navigate(`/charts`);
      }
    }
    if (actualPurpose === "filtersCharts") {
      dispatch(reducerPendingCharts({ id, selectId }));
      dispatch(
        reducerChartsFilters({ pageId: id, id: selectId, data: modalFilters })
      );
      dispatch(action(selectId, id)).then(() => {
        dispatch(reducerModalFilters(defaultFilter));
        dispatch(reducerPendingCharts({ id, selectId }));
      });
    }
    if (actualPurpose === "removeCharts") {
      dispatch(reducerSelectCharts(selectId));
    }
    if (actualPurpose === "screenCharts") {
      const printElement = printRef;

      if (printElement) {
        html2canvas(printElement).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imgData;
          link.download = "screenshot.png";
          link.click();
        });
      }

      dispatch(reducerChangeDataCharts({}));
    }
    if (actualPurpose === "skuload") {
      selectedFiles.length &&
        dispatch(actionImportProducts(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    if (actualPurpose === "changeColor") {
      dispatch(
        reducerSettingCharts({
          [dataCharts.type]: selectedChartsSettings,
          hasShadow: isHasShadowList,
        })
      );
      dispatch(actionAddDesktop());
    }
    if (actualPurpose === "logins") {
      selectedFiles.length &&
        dispatch(actionImportReportLogins(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    if (actualPurpose === "newReportsCreation") {
      selectedFiles.length &&
        dispatch(actionNewReportsCreation(selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    if (actualPurpose === "importCoefficients") {
      selectedFiles.length &&
        dispatch(actionImportCoefficients(selectId, selectedFiles)).then(() => {
          setSelectedFiles([]);
        });
    }
    document.body.style.overflow = "auto";
    setOpen(false);
  };

  const handleClickOpenBtn = (purpose: string, modalTitle: string) => {
    const openActions: any = {
      navigateToVacancyList: () => {
        if (!editForm) {
          dispatch(reducerHeaderBtn({ purpose, title: modalTitle }));
          const urlParams = new URLSearchParams(window.location.search);
          const source = urlParams.get("source");
          navigate(source || "/recruiting/vacancy");
        } else {
          dispatch(
            reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
          );
          setOpen(!open);
        }
      },
      createVacancyVacant: () => {
        if (CheckBeforeCreate(vacantCheckboxes) === "empty") {
          dispatch(
            reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
          );
          setOpen(true);
        }
      },
      createVacancyVacantRoutes: () => {
        if (CheckBeforeCreate(vacantCheckboxes) === "empty") {
          dispatch(
            reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
          );
          setOpen(!open);
        } else {
          setDisabledButton(true);
          dispatch(
            actionCreateVacancy(dataForCreate(vacantCheckboxes), "4", navigate)
          ).then(() => {
            setDisabledButton(false);
          });
        }
      },
      createVacancyRoutes: () => {
        if (CheckBeforeCreate(vacantCBnew) === "empty") {
          dispatch(
            reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
          );
          setOpen(!open);
        } else {
          setDisabledButton(true);
          dispatch(
            actionCreateVacancy(dataForCreate(vacantCBnew), "5", navigate)
          ).then(() => {
            setDisabledButton(false);
          });
          dispatch(reducerUpdatedData(true));
        }
      },
      createExpiredReports: () => {
        if (!reportsId.length) {
          dispatch(
            reducerExpiredReportsStatus({
              status: "noData",
              requestPurpose: "create",
            })
          );
        } else {
          if(!expiredReportsFilters.projects.length) {
            dispatch(actionGetFiltersExpiredReports(reportsId));
          }
          const selectedExpiredReportsList: any[] = [];
          reportsId.map((el: any) =>
            selectedExpiredReportsList.push(
              expiredReportsList.find(
                (report: any) => report.expiredReport.id === el.id
              )
            )
          );

          const shouldOpenModal = selectedExpiredReportsList.filter((el)=>!el.merch).length;
          if (shouldOpenModal) {
            setDisabledButton(true);
            dispatch(
              reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
            );
            setOpen(!open);
          } else {
            dispatch(actionCreateExpiredReports(reportsId));
          }
        }
      },
      visitSchedule: () => {
        return;
      },
      showVisitScheduleHistory: () => {
        dispatch(reducerVisitScheduleHistory(!isOpenHistory));
      },
      unloadScheduleExcel: () => {
        dispatch(actionUnloadScheduleInExcel());
      },
      sendRoutesToEasyMerch: () => {
        dispatch(actionSendRoutesToEasyMerch(0, selectedUsers));
      },
      addRouteOnVacancy: () => {
        dispatch(reducerSingleVacancyStatus(null));
        dispatch(reducerSingleVacancyStatusMessage(null));
        dispatch(
          reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
        );
        dispatch(
          reducerVacantRoutesInputValues({
            canBeAttachedToVacancy: true,
            project: inputValues.projects,
          })
        );
        setOpen(!open);
      },
      createEmployee: () => {
        navigate("/employees/create");
      },
      defaultAction: () => {
        dispatch(
          reducerHeaderBtn({ purpose, title: modalTitle, openModal: !open })
        );
        setOpen(!open);
      },
    };
    const action = openActions[purpose] || openActions.defaultAction;
    action();
  };

  const handleClickCloseBtn = () => {
    const action = closeActions[actualPurpose];
    if (
      actualPurpose === "createVacancyRoutes" ||
      actualPurpose === "createVacancyVacantRoutes"
    ) {
      const undInputValues = { ...vacancyCreateInputValues, type: "NO_ROUTE" };
      delete undInputValues.routesNo;
      delete undInputValues.project;
      dispatch(reducerCreateVacancyInputValues(undInputValues));
      dispatch(reducerHandleErrors(null));
      dispatch(reducerVacancyStatus(null));
      dispatch(reducerRoutesStatus(null));
      dispatch(reducerVacantRoutesStatus(null));
    }
    if (actualPurpose === "createVacancyVacant") {
      const undInputValues = { ...vacancyCreateInputValues, type: "NO_ROUTE" };
      delete undInputValues.routesNo;
      delete undInputValues.projects;
      delete undInputValues.projectRoutes;
      dispatch(reducerCreateVacancyInputValues(undInputValues));
      dispatch(reducerHandleErrors(null));
      dispatch(reducerVacancyStatus(null));
      dispatch(reducerRoutesStatus(null));
      dispatch(reducerVacantRoutesStatus(null));
    }
    if (actualPurpose === "lostVacancyRoutes") {
      dispatch(
        reducerSingleVacancyIV({
          ...inputValues,
          type: Object.keys(singleVacancyData.type.value)[0],
          editType: false,
        })
      );
      dispatch(
        reducerHeaderBtn({
          purpose: "lostVacancyRoutes",
          title: "Смена типа вакансии.",
          openModal: false,
        })
      );
    }
    if (actualPurpose === "addRouteOnVacancy") {
      dispatch(reducerVacantRoutesInputValues({ project: null }));
    }
    if (actualPurpose === "vacantRoutesSettings") {
      setSelectedVacantRoutesSettings(vacantRoutesSettings);
    }
    if (actualPurpose === "vacancyListSettings") {
      setSelectedVacancyListSettings(vacancyListSettings);
    }
    if (actualPurpose === "routesSettings") {
      setSelectedRoutesSettings(routesSettings);
    }
    if (actualPurpose === "adminReportsSettings") {
      setSelectedReportsSettings(adminReportsSettings);
      localStorage.setItem(
        "isSelectedAllAdminSettings",
        JSON.stringify(isCheckedFullInfo)
      );
    }
    if (actualPurpose === "newUsersClaims") {
      dispatch(reducerClearFilters());
    }
    if (actualPurpose === "reportCheck") {
      setSelectedActionOption("");
      setIsButtonName("Принять");
    }

    if (actualPurpose === "createExpiredReports") {
      dispatch(
        reducerExpiredRecordsModalCreateValues({
          projects: [],
          merchs: [],
          svs: [],
          vsv: [],
        })
      );
      setDisabledButton(false);
    }

    if (actualPurpose === "filtersCharts") {
      dispatch(reducerModalFilters(defaultFilter));
    }
    if (actualPurpose === "editDesktop") {
      setDisabledButton(false);
    }
    if (action) {
      action();
    }
    document.body.style.overflow = "auto";
    setSelectedFiles([]);
    setOpen(false);
    setError("");
  };

  const handleClickRejectBtn = () => {
    setIsClickRejectBtn(true);
    dispatch(
      reducerHeaderBtn({
        purpose: "deleteDesktop",
        title: "Удалить рабочий стол?",
      })
    );
  };

  const handleChangeLimitInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReportLimit(event.target.value);
    setError("");
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const fileList = Array.from(files);
      if (purpose === "logins") {
        setSelectedFiles(fileList);
      } else if (purpose === "importCoefficients") {
          const file_ = files[0];
          setSelectedFiles([file_]);
      }
      else {
        setSelectedFiles([...selectedFiles, ...fileList]);
      }
    }
  };

  const generateLimitSection = () => (
    <LimitSection
      handleChangeLimitInput={handleChangeLimitInput}
      error={error}
    />
  );

  const sectionComponents: any = {
    addressInfo: (
      <ScheduleAddressInfoSection content={content} selectId={selectId} />
    ),
    unloadReportsConsolidated: generateLimitSection(),
    unloadCustomerReportsData: generateLimitSection(),
    unloadReportsWithLinks: generateLimitSection(),
    unloadCustomerReports: generateLimitSection(),
    unloadReportsTander: generateLimitSection(),
    unloadScheduleExcel: generateLimitSection(),
    unloadClientReport: generateLimitSection(),
    unloadReportsList: generateLimitSection(),
    unloadExpiredList: generateLimitSection(),
    averageFacing: generateLimitSection(),
    unloadHotline: generateLimitSection(),
    shelfShare: generateLimitSection(),
    unloadStafftReport: generateLimitSection(),
    companyStaff: generateLimitSection(),
    actionExportTanderProducts: generateLimitSection(),
    deletePhotos: <DeletePhotosSection />,
    createGeo: <CreateGeoSection />,
      consolidatedBudgeExport: <ConsolidatedBudgetExportSection />,
    osa: generateLimitSection(),
    addRouteOnVacancy: <AddRouteOnVacancySection />,
    createExpiredReports: <CreateExpiredReportsSection />,
    deleteExpired: (
      <DeleteReportSection title="Вы уверены, что хотите удалить выбранные отчеты ?" />
    ),
    navigateToVacancyList: (
      <NavigateToSection title="Вернуться к списку вакансий без сохранения изменений ?" />
    ),
    navigateToProjectsList: (
      <NavigateToSection title="Вернуться к списку проектов без сохранения изменений ?" />
    ),
    navigateToApplicationsList: (
      <NavigateToSection title="Вернуться к списку анкет без сохранения изменений ?" />
    ),
    deleteReport: (
      <DeleteReportSection title="Вы уверены, что хотите удалить отчет ?" />
    ),
    removeSelections: <DeleteRouteSection title="Снять выделения ?" />,
    deleteRoute: <DeleteRouteSection title="Удалить маршрут с вакансии ?" />,
    vacancyUpdate: <VacancyUpdateSection title={"Сохранить изменения ?"} />,
    createVacancy: <CreateVacancy title="Создать вакансию ?" />,
    newApplication: <NewApplication title="Создать анкету ?" />,
    newUsersClaims: <NewUsersClaims />,
    createVacancyVacant: <VacancyCreateNewSection title="Создать вакансию ?" />,
    createVacancyVacantRoutes: (
      <VacancyCreateNewSection title="Создать вакансию ?" />
    ),
    createVacancyRoutes: <VacancyCreateNewSection title="Создать вакансию ?" />,
    lostVacancyRoutes: (
      <LostVacancyRoutestSection title="При сохранении данного типа вакансии будет потеряна связь со всеми маршрутами. Сменить тип маршрута ?" />
    ),
    reportCheck: (
      <ReportCheckSection
        setSelectedReportCheckReasons={setSelectedReportCheckReasons}
        selectedReportCheckReasons={selectedReportCheckReasons}
        setSelectedCheckTypeOption={setSelectedCheckTypeOption}
        setReportCheckCommentValue={setReportCheckCommentValue}
        selectedCheckTypeOption={selectedCheckTypeOption}
        reportCheckCommentValue={reportCheckCommentValue}
        setSelectedActionOption={setSelectedActionOption}
        selectedActionOption={selectedActionOption}
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        setIsButtonName={setIsButtonName}
        setIsError={setReportCheckError}
        selectedFiles={selectedFiles}
        isError={reportCheckError}
      />
    ),
    updateReviewStatus: (
      <UpdateReviewStatusSection
        setSelectedOption={setSelectedReviewStatusOption}
        setSelectedReason={setSelectedReviewReasonId}
        setReviewReasonError={setReviewReasonError}
        reviewReasonError={reviewReasonError}
      />
    ),
    unloadReportsPhotos: (
      <UnloadReportsPhotoSection
        setSelectedCustomServices={setSelectedCustomServices}
        handleChangeLimitInput={handleChangeLimitInput}
        setSelectedActions={setSelectedActions}
        error={error}
      />
    ),
    customerReportsSettings: (
      <CustomerReportsSettingsSection
        setSelectedSettings={setSelectedReportsSettings}
        selectedSettings={selectedReportsSettings}
        setIsCheckedFullInfo={setIsCheckedAllSettings}
        isCheckedFullInfo={isCheckedAllSettings}
      />
    ),
    employeesListSettings: (
      <EmployeesListSettingsSection
        setSelectedSettings={setSelectedEmployeesListSettings}
        selectedSettings={selectedEmployeesListSettings}
        setIsCheckedFullInfo={setIsCheckedAllEmployeesListSettings}
        isCheckedFullInfo={isCheckedAllEmployeesListSettings}
      />
    ),
    firedListSettings: (
      <FiredListSettingsSection
        setSelectedSettings={setSelectedFiredListSettings}
        selectedSettings={selectedFiredListSettings}
        setIsCheckedFullInfo={setIsCheckedAllFiredListSettings}
        isCheckedFullInfo={isCheckedAllFiredListSettings}
      />
    ),
    adminReportsSettings: (
      <AdminReportsSettingsSection
        setSelectedSettings={setSelectedReportsSettings}
        selectedSettings={selectedReportsSettings}
        setIsCheckedFullInfo={setIsCheckedAllSettings}
        isCheckedFullInfo={isCheckedAllSettings}
      />
    ),
    expiredReportsSettings: (
      <ExpiredReportsSettingsSection
        setSelectedSettings={setSelectedExpiredReportsSettings}
        selectedSettings={selectedExpiredReportsSettings}
        setIsCheckedFullInfo={setIsCheckedAllExpiredSettings}
        isCheckedFullInfo={isCheckedAllExpiredSettings}
      />
    ),
    routesSettings: (
      <RoutesSettingsSection
        setSelectedRoutesSettings={setSelectedRoutesSettings}
        selectedRoutesSettings={selectedRoutesSettings}
        setIsCheckedFullInfo={setIsCheckedAllRoutesSettings}
        isCheckedFullInfo={isCheckedAllRoutesSettings}
      />
    ),
    vacantRoutesSettings: (
      <VacantRoutesSettingsSection
        setSelectedSettings={setSelectedVacantRoutesSettings}
        selectedSettings={selectedVacantRoutesSettings}
        setIsCheckedFullInfo={setIsCheckedAllVacantRoutesSettings}
        isCheckedFullInfo={isCheckedAllVacantRoutesSettings}
      />
    ),
    vacancyListSettings: (
      <VacancyListSettingsSection
        setSelectedSettings={setSelectedVacancyListSettings}
        selectedSettings={selectedVacancyListSettings}
        setIsCheckedFullInfo={setIsCheckedAllVacancyListSettings}
        isCheckedFullInfo={isCheckedAllVacancyListSettings}
      />
    ),
    singleReportSettings: (
      <SingleReportSettingsSection
        setReorderedReportOptions={setReorderedReportOptions}
        setSelectedReportTabs={setSelectedReportTabs}
        setIsCheckedFullInfo={setIsCheckedFullInfo}
        selectedReportTabs={selectedReportTabs}
        isCheckedFullInfo={isCheckedFullInfo}
      />
    ),
    adminSingleReportSettings: (
      <AdminSingleReportSettingsSection
        setReorderedReportOptions={setReorderedReportOptions}
        setSelectedReportTabs={setSelectedReportTabs}
        setIsCheckedFullInfo={setIsCheckedFullInfo}
        selectedReportTabs={selectedReportTabs}
        isCheckedFullInfo={isCheckedFullInfo}
      />
    ),
    chartsSettings: (
      <ChartsSettingsSection
        setReorderedReportOptions={setReorderedReportOptions}
        setIsCheckedFullInfo={setIsCheckedAllChartsSettings}
        setSelectedSettings={setSelectedChartsSettings}
        isCheckedFullInfo={isCheckedAllChartsSettings}
        selectedSettings={selectedChartsSettings}
        selectedId={setIsPageId}
      />
    ),
    createReports: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    uploadKPI: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    outletsDownload: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    copyReport: (
      <CopyReportSection
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
        setWithGeolocations={setWithGeolocations}
        withGeolocations={withGeolocations}
      />
    ),
    copyReports: (
      <CopyReportSection
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
        setWithGeolocations={setWithGeolocations}
        withGeolocations={withGeolocations}
      />
    ),
    updateDeliveryStatus: (
      <UpdateDeliveryStatusSection
        setSelectedOption={setSelectedDeliveryOption}
      />
    ),
    updateRateStatus: (
      <UpdateRateStatusSection
        setSelectedOption={setSelectedRateStatusOption}
      />
    ),
    changeShiftStart: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    changeEmployeePay: <ChangeEmployeePaySection />,
    fireAnEmployee: <FiredAnEmployeeSection />,
    reinstateAnEmployee: <ReinstateAnEmployeeSection />,
    blockEmployee: <BlockEmployeeSection />,
    loadingContracts: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    loadingMail: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    massLayoff: (
      <FiredAnEmployeeSection selectedEmployees={selectedEmployeesId} />
    ),
    unloadModifiedData: (
      <CopyReportSection
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
        setWithGeolocations={setWithGeolocations}
        withGeolocations={withGeolocations}
      />
    ),
    legend: <LegendMapSection />,
    editDesktop: (
      <EditDesktopOnCharts
        setDisabledButton={setDisabledButton}
        setState={setIsNewDesktopName}
        id={id}
      />
    ),
    addDesktop: <AddedDesktopOnCharts setState={setIsNewDesktopName} />,
    addChart: <AddChartSection id={id} />,
    filtersCharts: (
      <FiltersChartSection
        id={id}
        chartId={selectId}
        inputValues={inputValuesCharts}
      />
    ),
    screenCharts: (
      <ScreenshotChartSection data={dataCharts} setPrintRef={setPrintRef} />
    ),
    logins: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    importCoefficients: (
        <OutletsDownloadSection
            handleFileChange={handleFileChange}
            setSelectedFiles={setSelectedFiles}
            selectedFiles={selectedFiles}
            setIsDisabled={setDisabledButton}
        />
    ),
      skuload: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />
    ),
    changeColor: (
      <ChangeColorSection
        dataCharts={dataCharts}
        setSelectedSettings={setSelectedChartsSettings}
        setIsHasShadowList={setIsHasShadowList}
      />
    ),
    newReportsCreation: (
      <OutletsDownloadSection
        handleFileChange={handleFileChange}
        setSelectedFiles={setSelectedFiles}
        selectedFiles={selectedFiles}
        setIsDisabled={setDisabledButton}
      />),
  };

  useEffect(() => {
    if (
      inputValues.type === "LOST_ROUTE" &&
      inputValues.editType &&
      !open &&
      openModal
    ) {
      setOpen(!open);
    }
    if (
      actualPurpose === "lostVacancyRoutes" &&
      (inputValues.type !== "LOST_ROUTE" || !openModal)
    ) {
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValues.editType, open, openModal]);

  useEffect(()=>{
    const findEmptyField = Object.values(expiredReportsModalData).filter((el: any)=>!el.length);
    if(!findEmptyField.length) { setDisabledButton(false)}
  }, [expiredReportsModalData]);

  return (
    <>
      <div
        className={
          isOpenHistory && purpose === "showVisitScheduleHistory"
            ? styles.active__header_btn
            : purpose === "addressInfo"
            ? styles.address__link
            : purpose === "removeCharts" ||
              purpose === "filtersCharts" ||
              purpose === "screenCharts" ||
              purpose === "changeColor"
            ? styles.header__btn_chacts
            : purpose === "addDesktop"
            ? styles.header__btn_desktop
            : purpose === "shelfShare"
            ? styles.header__btn_shelf
            : styles.header__btn
        }
        onClick={() => {
          !disabledButton && handleClickOpenBtn(purpose, modalTitle);
        }}
      >
        {hasIcon && (
          <img
            src={hasIcon === "excel" ? Excel : Zip}
            alt="excel"
            className={styles.header__btn_icon}
          />
        )}
        <span className={styles.header__btn_content}>{content}</span>
      </div>
      <CSSTransition in={open} timeout={400} classNames="alert" unmountOnExit>
        <Blackout onClose={handleClickCloseBtn}>
          <div
            className={
              purpose === "unloadReportsPhotos" || purpose === "addressInfo" || purpose === "reportCheck"
                ? styles.long__modal
                : purpose === "createVacancyVacantRoutes"
                ? styles.tall__modal
                : purpose === "newApplication" ||
                  purpose === "newUsersClaims" ||
                  purpose === "reinstateAnEmployee"
                ? styles.modal__application
                : purpose === "filtersCharts" || purpose === "screenCharts"
                ? styles.modal__charts
                : styles.modal
            }
            id="headerBtnModal"
            onClick={(event: React.MouseEvent<HTMLDivElement>) =>
              event.stopPropagation()
            }
          >
            <div className={styles.modal__title_block}>
              <span>{actualModalTitle}</span>
              {purpose === "reportCheck" && (
                <button
                  className={styles.headerBtnMinimize}
                  onClick={() => setOpen(false)}
                >
                  <span className={styles.headerBtnMinimize_span}></span>
                </button>
              )}
              <img
                style={{ cursor: "pointer" }}
                onClick={handleClickCloseBtn}
                src={Close}
                alt="close"
              />
            </div>
            {actualPurpose !== "outletsUnload" &&
              actualPurpose !== "errorsUnload" && (
                <div
                  className={
                    actualPurpose &&
                    (actualPurpose === "reportCheck"
                      ? styles.reportCheck__content_block
                      : actualPurpose.includes("Settings")
                      ? styles.settings__content_block
                      : actualPurpose === "createVacancyVacant" ||
                        actualPurpose === "createVacancyRoutes" ||
                        actualPurpose === "createVacancyVacantRoutes"
                      ? styles.vacancy__content_block
                      : styles.content__block)
                  }
                >
                  {sectionComponents[actualPurpose]}
                </div>
              )}
            {purpose !== "legend" && (
              <div className={styles.btn__block}>
                {actualPurpose !== "addressInfo" && (
                  <button
                    className={styles.accept__btn}
                    disabled={disabledButton}
                    onClick={handleClickApplyBtn}
                  >
                    {purpose === "reportCheck" ? isButtonName : "Применить"}
                  </button>
                )}
                {(purpose === "verifyPhoto" ||
                  (purpose === "editDesktop" && !isClickRejectBtn)) && (
                  <button
                    className={clsx(
                      styles.cancel__btn,
                      purpose === "editDesktop" && styles.cancel__btn_remove
                    )}
                    onClick={handleClickRejectBtn}
                  >
                    {purpose === "editDesktop" ? "Удалить" : "Отклонить"}
                  </button>
                )}
                <button
                  className={styles.cancel__btn}
                  onClick={handleClickCloseBtn}
                >
                  Отмена
                </button>
              </div>
            )}
          </div>
        </Blackout>
      </CSSTransition>
    </>
  );
};

export default HeaderBtn;
